export enum IntegrationType {
  Email = 0,
  Calendar = 1,
  Editor = 2,
  PublicPortal = 3,
  InvoiceSystem = 4,
}
